import { PlusOutlined } from '@ant-design/icons';
import { ModalTrigger } from '@arivaa-react/components/modal';
import { Button, Tooltip } from 'antd';
import { ApiForm } from '../../../containers/apiForm';
import { url } from '../../../constants/api';
import { useCrudRecord } from '../../../containers/crud/recordContext';

export const ExtendTrialLicence = () => {
  const { key: websiteId } = useCrudRecord();
  return (
    <ModalTrigger
      modalProps={{
        title: 'Extend Trial Licence',
        footer: null,
      }}
      content={
        <ApiForm
          apiUrl={url(`website-plans/trial-licence/${websiteId}`)}
          method="POST"
          elements={[
            {
              type: 'number',
              label: 'Plan Duration in days',
              name: 'duration',
              required: true,
              inputProps: {
                min: 0,
              },
            },
          ]}
          rules={[
            {
              required: true,
              message: 'Plan duration is Required',
            },
          ]}
        />
      }
    >
      <Tooltip title="Extend Trial Licence" placement="bottom">
        <Button className="btn blue-btn-text">
          <PlusOutlined />
        </Button>
      </Tooltip>
    </ModalTrigger>
  );
};
